// 해당 값이 변동이 있을시 공유 필요(SP1)
export const getRegionCode = [
  { key: "AllCountryCode", value: "allcountrycode" },
  { key: "Andorra", value: "AD" },
  { key: "United Arab Emirates (the)", value: "AE" },
  { key: "Afghanistan", value: "AF" },
  { key: "Antigua and Barbuda", value: "AG" },
  { key: "Anguilla", value: "AI" },
  { key: "Albania", value: "AL" },
  { key: "Armenia", value: "AM" },
  { key: "Angola", value: "AO" },
  { key: "Antarctica", value: "AQ" },
  { key: "Argentina", value: "AR" },
  { key: "American Samoa", value: "AS" },
  { key: "Austria", value: "AT" },
  { key: "Australia", value: "AU" },
  { key: "Aruba", value: "AW" },
  { key: "Åland Islands", value: "AX" },
  { key: "Azerbaijan", value: "AZ" },
  { key: "Bosnia and Herzegovina", value: "BA" },
  { key: "Barbados", value: "BB" },
  { key: "Bangladesh", value: "BD" },
  { key: "Belgium", value: "BE" },
  { key: "Burkina Faso", value: "BF" },
  { key: "Bulgaria", value: "BG" },
  { key: "Bahrain", value: "BH" },
  { key: "Burundi", value: "BI" },
  { key: "Benin", value: "BJ" },
  { key: "Saint Barthélemy", value: "BL" },
  { key: "Bermuda", value: "BM" },
  { key: "Brunei Darussalam", value: "BN" },
  { key: "Bolivia (Plurinational State of)", value: "BO" },
  { key: "Bonaire, Sint Eustatius and Saba", value: "BQ" },
  { key: "Brazil", value: "BR" },
  { key: "Bahamas (the)", value: "BS" },
  { key: "Bhutan", value: "BT" },
  { key: "Bouvet Island", value: "BV" },
  { key: "Botswana", value: "BW" },
  { key: "Belarus", value: "BY" },
  { key: "Belize", value: "BZ" },
  { key: "Canada", value: "CA" },
  { key: "Cocos (Keeling) Islands (the)", value: "CC" },
  { key: "Congo (the Democratic Republic of the)", value: "CD" },
  { key: "Central African Republic (the)", value: "CF" },
  { key: "Congo (the)", value: "CG" },
  { key: "Switzerland", value: "CH" },
  { key: "Côte d'Ivoire", value: "CI" },
  { key: "Cook Islands (the)", value: "CK" },
  { key: "Chile", value: "CL" },
  { key: "Cameroon", value: "CM" },
  { key: "China", value: "CN" },
  { key: "Colombia", value: "CO" },
  { key: "Costa Rica", value: "CR" },
  { key: "Cuba", value: "CU" },
  { key: "Cabo Verde", value: "CV" },
  { key: "Curaçao", value: "CW" },
  { key: "Christmas Island", value: "CX" },
  { key: "Cyprus", value: "CY" },
  { key: "Czechia", value: "CZ" },
  { key: "Germany", value: "DE" },
  { key: "Djibouti", value: "DJ" },
  { key: "Denmark", value: "DK" },
  { key: "Dominica", value: "DM" },
  { key: "Dominican Republic (the)", value: "DO" },
  { key: "Algeria", value: "DZ" },
  { key: "Ecuador", value: "EC" },
  { key: "Estonia", value: "EE" },
  { key: "Egypt", value: "EG" },
  { key: "Western Sahara*", value: "EH" },
  { key: "Eritrea", value: "ER" },
  { key: "Spain", value: "ES" },
  { key: "Ethiopia", value: "ET" },
  { key: "Finland", value: "FI" },
  { key: "Fiji", value: "FJ" },
  { key: "Falkland Islands (the) [Malvinas]", value: "FK" },
  { key: "Micronesia (Federated States of)", value: "FM" },
  { key: "Faroe Islands (the)", value: "FO" },
  { key: "France", value: "FR" },
  { key: "Gabon", value: "GA" },
  {
    key: "United Kingdom of Great Britain and Northern Ireland (the)",
    value: "GB",
  },
  { key: "Grenada", value: "GD" },
  { key: "Georgia", value: "GE" },
  { key: "French Guiana", value: "GF" },
  { key: "Guernsey", value: "GG" },
  { key: "Ghana", value: "GH" },
  { key: "Gibraltar", value: "GI" },
  { key: "Greenland", value: "GL" },
  { key: "Gambia (the)", value: "GM" },
  { key: "Guinea", value: "GN" },
  { key: "Guadeloupe", value: "GP" },
  { key: "Equatorial Guinea", value: "GQ" },
  { key: "Greece", value: "GR" },
  { key: "South Georgia and the South Sandwich Islands", value: "GS" },
  { key: "Guatemala", value: "GT" },
  { key: "Guam", value: "GU" },
  { key: "Guinea-Bissau", value: "GW" },
  { key: "Guyana", value: "GY" },
  { key: "Hong Kong", value: "HK" },
  { key: "Heard Island and McDonald Islands", value: "HM" },
  { key: "Honduras", value: "HN" },
  { key: "Croatia", value: "HR" },
  { key: "Haiti", value: "HT" },
  { key: "Hungary", value: "HU" },
  { key: "Indonesia", value: "ID" },
  { key: "Ireland", value: "IE" },
  { key: "Israel", value: "IL" },
  { key: "Isle of Man", value: "IM" },
  { key: "India", value: "IN" },
  { key: "British Indian Ocean Territory (the)", value: "IO" },
  { key: "Iraq", value: "IQ" },
  { key: "Iran (Islamic Republic of)", value: "IR" },
  { key: "Iceland", value: "IS" },
  { key: "Italy", value: "IT" },
  { key: "Jersey", value: "JE" },
  { key: "Jamaica", value: "JM" },
  { key: "Jordan", value: "JO" },
  { key: "Japan", value: "JP" },
  { key: "Kenya", value: "KE" },
  { key: "Kyrgyzstan", value: "KG" },
  { key: "Cambodia", value: "KH" },
  { key: "Kiribati", value: "KI" },
  { key: "Comoros (the)", value: "KM" },
  { key: "Saint Kitts and Nevis", value: "KN" },
  { key: "Korea (the Democratic People's Republic of)", value: "KP" },
  { key: "Korea (the Republic of)", value: "KR" },
  { key: "Kuwait", value: "KW" },
  { key: "Cayman Islands (the)", value: "KY" },
  { key: "Kazakhstan", value: "KZ" },
  { key: "Lao People's Democratic Republic (the)", value: "LA" },
  { key: "Lebanon", value: "LB" },
  { key: "Saint Lucia", value: "LC" },
  { key: "Liechtenstein", value: "LI" },
  { key: "Sri Lanka", value: "LK" },
  { key: "Liberia", value: "LR" },
  { key: "Lesotho", value: "LS" },
  { key: "Lithuania", value: "LT" },
  { key: "Luxembourg", value: "LU" },
  { key: "Latvia", value: "LV" },
  { key: "Libya", value: "LY" },
  { key: "Morocco", value: "MA" },
  { key: "Monaco", value: "MC" },
  { key: "Moldova (the Republic of)", value: "MD" },
  { key: "Montenegro", value: "ME" },
  { key: "Saint Martin (French part)", value: "MF" },
  { key: "Madagascar", value: "MG" },
  { key: "Marshall Islands (the)", value: "MH" },
  { key: "North Macedonia", value: "MK" },
  { key: "Mali", value: "ML" },
  { key: "Myanmar", value: "MM" },
  { key: "Mongolia", value: "MN" },
  { key: "Macao", value: "MO" },
  { key: "Northern Mariana Islands (the)", value: "MP" },
  { key: "Martinique", value: "MQ" },
  { key: "Mauritania", value: "MR" },
  { key: "Montserrat", value: "MS" },
  { key: "Malta", value: "MT" },
  { key: "Mauritius", value: "MU" },
  { key: "Maldives", value: "MV" },
  { key: "Malawi", value: "MW" },
  { key: "Mexico", value: "MX" },
  { key: "Malaysia", value: "MY" },
  { key: "Mozambique", value: "MZ" },
  { key: "Namibia", value: "NA" },
  { key: "New Caledonia", value: "NC" },
  { key: "Niger (the)", value: "NE" },
  { key: "Norfolk Island", value: "NF" },
  { key: "Nigeria", value: "NG" },
  { key: "Nicaragua", value: "NI" },
  { key: "Netherlands (Kingdom of the)", value: "NL" },
  { key: "Norway", value: "NO" },
  { key: "Nepal", value: "NP" },
  { key: "Nauru", value: "NR" },
  { key: "Niue", value: "NU" },
  { key: "New Zealand", value: "NZ" },
  { key: "Oman", value: "OM" },
  { key: "Panama", value: "PA" },
  { key: "Peru", value: "PE" },
  { key: "French Polynesia", value: "PF" },
  { key: "Papua New Guinea", value: "PG" },
  { key: "Philippines (the)", value: "PH" },
  { key: "Pakistan", value: "PK" },
  { key: "Poland", value: "PL" },
  { key: "Saint Pierre and Miquelon", value: "PM" },
  { key: "Pitcairn", value: "PN" },
  { key: "Puerto Rico", value: "PR" },
  { key: "Palestine, State of", value: "PS" },
  { key: "Portugal", value: "PT" },
  { key: "Palau", value: "PW" },
  { key: "Paraguay", value: "PY" },
  { key: "Qatar", value: "QA" },
  { key: "Réunion", value: "RE" },
  { key: "Romania", value: "RO" },
  { key: "Serbia", value: "RS" },
  { key: "Russian Federation (the)", value: "RU" },
  { key: "Rwanda", value: "RW" },
  { key: "Saudi Arabia", value: "SA" },
  { key: "Solomon Islands", value: "SB" },
  { key: "Seychelles", value: "SC" },
  { key: "Sudan (the)", value: "SD" },
  { key: "Sweden", value: "SE" },
  { key: "Singapore", value: "SG" },
  { key: "Saint Helena, Ascension and Tristan da Cunha", value: "SH" },
  { key: "Slovenia", value: "SI" },
  { key: "Svalbard and Jan Mayen", value: "SJ" },
  { key: "Slovakia", value: "SK" },
  { key: "Sierra Leone", value: "SL" },
  { key: "San Marino", value: "SM" },
  { key: "Senegal", value: "SN" },
  { key: "Somalia", value: "SO" },
  { key: "Suriname", value: "SR" },
  { key: "South Sudan", value: "SS" },
  { key: "Sao Tome and Principe", value: "ST" },
  { key: "El Salvador", value: "SV" },
  { key: "Sint Maarten (Dutch part)", value: "SX" },
  { key: "Syrian Arab Republic (the)", value: "SY" },
  { key: "Eswatini", value: "SZ" },
  { key: "Turks and Caicos Islands (the)", value: "TC" },
  { key: "Chad", value: "TD" },
  { key: "French Southern Territories (the)", value: "TF" },
  { key: "Togo", value: "TG" },
  { key: "Thailand", value: "TH" },
  { key: "Tajikistan", value: "TJ" },
  { key: "Tokelau", value: "TK" },
  { key: "Timor-Leste", value: "TL" },
  { key: "Turkmenistan", value: "TM" },
  { key: "Tunisia", value: "TN" },
  { key: "Tonga", value: "TO" },
  { key: "Türkiye", value: "TR" },
  { key: "Trinidad and Tobago", value: "TT" },
  { key: "Tuvalu", value: "TV" },
  { key: "Taiwan (Province of China)", value: "TW" },
  { key: "Tanzania, the United Republic of", value: "TZ" },
  { key: "Ukraine", value: "UA" },
  { key: "Uganda", value: "UG" },
  { key: "United States Minor Outlying Islands (the)", value: "UM" },
  { key: "United States of America (the)", value: "US" },
  { key: "Uruguay", value: "UY" },
  { key: "Uzbekistan", value: "UZ" },
  { key: "Holy See (the)", value: "VA" },
  { key: "Saint Vincent and the Grenadines", value: "VC" },
  { key: "Venezuela (Bolivarian Republic of)", value: "VE" },
  { key: "Virgin Islands (British)", value: "VG" },
  { key: "Virgin Islands (U.S.)", value: "VI" },
  { key: "Viet Nam", value: "VN" },
  { key: "Vanuatu", value: "VU" },
  { key: "Wallis and Futuna", value: "WF" },
  { key: "Samoa", value: "WS" },
  { key: "Kosova", value: "XK" },
  { key: "Yemen", value: "YE" },
  { key: "Mayotte", value: "YT" },
  { key: "South Africa", value: "ZA" },
  { key: "Zambia", value: "ZM" },
  { key: "Zimbabwe", value: "ZW" },
  { key: "", value: "" },
];

export const getAllCountryCode = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AQ",
  "AG",
  "AR",
  "AM",
  "AW",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "GB",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CM",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CD",
  "CG",
  "CI",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "DK",
  "DJ",
  "DM",
  "DO",
  "TL",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GU",
  "GT",
  "GG",
  "GW",
  "GN",
  "GY",
  "HT",
  "HM",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "KR",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MK",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MH",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "FM",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MP",
  "NO",
  "OM",
  "PK",
  "PW",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "PR",
  "QA",
  "RE",
  "RO",
  "RU",
  "RW",
  "AS",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "SS",
  "ES",
  "LK",
  "BL",
  "SH",
  "KN",
  "LC",
  "SX",
  "MF",
  "PM",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SZ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TG",
  "TK",
  "TO",
  "TT",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "US",
  "UY",
  "UM",
  "UZ",
  "VU",
  "VA",
  "VE",
  "VN",
  "VG",
  "VI",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
];

export const dummyRegionCode = [
  "allcountrycode",
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua & Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia & Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "Britain (UK)",
  "British Indian Ocean Territory",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Caribbean NL",
  "Cayman Islands",
  "Central African Rep.",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo (Dem. Rep.)",
  "Congo (Rep.)",
  "Côte d'Ivoire",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern & Antarctic Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea-Bissau",
  "Guinea",
  "Guyana",
  "Haiti",
  "Heard Island & McDonald Islands",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (North)",
  "Korea (South)",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Réunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Samoa (American)",
  "Samoa (western)",
  "San Marino",
  "Sao Tome & Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia & the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "St Barthelemy",
  "St Helena",
  "St Kitts & Nevis",
  "St Lucia",
  "St Maarten (Dutch)",
  "St Martin (French)",
  "St Pierre & Miquelon",
  "St Vincent",
  "Sudan",
  "Suriname",
  "Svalbard & Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad & Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks & Caicos Is",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United States",
  "Uruguay",
  "US minor outlying islands",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (UK)",
  "Virgin Islands (US)",
  "Wallis & Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe-",
];
